import { ClbDrawer } from '@celebration/react/ClbDrawer/ClbDrawer';
import { ClbDrawerProps } from '@celebration/react/ClbDrawer/ClbDrawer.types';

export default function Drawer({
    children,
    ...props
}: Readonly<ClbDrawerProps>) {
    return <ClbDrawer {...props}>{children}</ClbDrawer>;
}
